import React from 'react';

import CyberFarmFactories from '../../components/CyberFarm/CyberFarmFactoriesPage/CyberFarmFactories/CyberFarmFactories';




const CyberFarmFactoriesPage: React.FC = () => {
  return (
  <CyberFarmFactories/>
  );
};

export default CyberFarmFactoriesPage; 